// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__MN4vG","right":"styles_right__2_hmN"};